import { lazy, Suspense, type ReactNode } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AdminLayout } from '../components/layout/AdminLayout'
import { LoadingBlock } from '../components/feedback/States'
import { ProtectedRoute } from '../features/auth/ProtectedRoute'

const Login = lazy(() => import('../features/auth/LoginPage'))
const Dashboard = lazy(() => import('../features/dashboard/DashboardPage'))
const Agents = lazy(() => import('../features/agents/AgentsPage'))
const Farmers = lazy(() => import('../features/farmers/FarmersPage'))
const Ads = lazy(() => import('../features/ads/AdsPage'))
const Catalog = lazy(() => import('../features/catalog/CatalogPage'))
const Unlock = lazy(() => import('../features/notifications/UnlockRequestsPage'))
const Analytics = lazy(() => import('../features/analytics/AnalyticsPage'))
const Feed = lazy(() => import('../features/feed/FeedPage'))
import { PushPlanningPage, SettingsPage } from '../features/common/PlanningPages'
const AdminPosts = lazy(() => import('../features/feed/AdminPostsPage'))

const pending = <div className="route-loading"><LoadingBlock rows={6} /></div>
const lazyElement = (node: ReactNode) => <Suspense fallback={pending}>{node}</Suspense>

export const router = createBrowserRouter([
  { path: '/login', element: lazyElement(<Login />) },
  { element: <ProtectedRoute />, children: [{ element: <AdminLayout />, children: [
    { index: true, element: lazyElement(<Dashboard />) },
    { path: 'agents', element: lazyElement(<Agents />) },
    { path: 'farmers', element: lazyElement(<Farmers />) },
    { path: 'ads', element: lazyElement(<Ads />) },
    { path: 'catalog', element: lazyElement(<Catalog />) },
    { path: 'unlock-requests', element: lazyElement(<Unlock />) },
    { path: 'analytics', element: lazyElement(<Analytics />) },
    { path: 'content/feed', element: lazyElement(<Feed />) },
    { path: 'content/admin-posts', element: lazyElement(<AdminPosts />) },
    { path: 'notifications', element: <PushPlanningPage /> },
    { path: 'settings', element: <SettingsPage /> },
  ] }] },
  { path: '*', element: <Navigate to="/" replace /> },
])
